/* eslint-disable sonarjs/cognitive-complexity */ // Main function to wait for a property to be set
export default function whenPropertyIsSet(target, prop, timeout) {
    if (timeout === void 0) timeout = 0;
    var _originalDescriptor, _originalDescriptor1;
    if (target === null || typeof target !== "object") {
        throw new Error("Target must be an object");
    }
    // Resolve immediately if the property already exists or is not writable/configurable
    if (typeof target[prop] !== "undefined") {
        return Promise.resolve(target[prop]);
    }
    var originalDescriptor = Object.getOwnPropertyDescriptor(target, prop);
    if (((_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.configurable) === false || ((_originalDescriptor1 = originalDescriptor) == null ? void 0 : _originalDescriptor1.writable) === false) {
        return Promise.resolve(target[prop]);
    }
    // Return a promise that resolves when the property is set
    var hasSettled = false;
    return new Promise(function(resolve, reject) {
        var _originalDescriptor;
        var _originalDescriptor_enumerable;
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: (_originalDescriptor_enumerable = (_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.enumerable) != null ? _originalDescriptor_enumerable : true,
            get: function() {
                var _originalDescriptor, _originalDescriptor1;
                return ((_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.get) ? originalDescriptor.get.call(this) : (_originalDescriptor1 = originalDescriptor) == null ? void 0 : _originalDescriptor1.value;
            },
            set: function(value) {
                if (!hasSettled) {
                    hasSettled = true;
                    // Restore original property descriptor
                    if (originalDescriptor) {
                        Object.defineProperty(target, prop, originalDescriptor);
                        target[prop] = value;
                    } else {
                        Object.defineProperty(target, prop, {
                            value: value,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    }
                    setTimeout(resolve, 0, value);
                }
            }
        });
        if (timeout > 0) {
            setTimeout(function() {
                if (!hasSettled) {
                    reject(new Error("Property " + prop + " was not set within " + timeout + "ms"));
                }
            }, timeout);
        }
    });
}

//# sourceMappingURL=whenPropertyIsSet.js.map